export var PROPS_KEY;
(function(PROPS_KEY2) {
  PROPS_KEY2["name"] = "name";
  PROPS_KEY2["decorator"] = "x-decorator";
  PROPS_KEY2["decoratorProps"] = "x-decorator-props";
  PROPS_KEY2["component"] = "x-component";
  PROPS_KEY2["componentProps"] = "x-component-props";
  PROPS_KEY2["path"] = "c-path";
  PROPS_KEY2["dataMap"] = "c-data-map";
  PROPS_KEY2["commonDeps"] = "c-common-deps";
  PROPS_KEY2["commonUntrackedDeps"] = "c-common-untracked-deps";
  PROPS_KEY2["actions"] = "c-actions";
  PROPS_KEY2["value"] = "c-value";
})(PROPS_KEY || (PROPS_KEY = {}));
